<template>

  <CommonPrivateView>
    <template v-slot:header>
      
      <div class="w-full flex flex-row py-6 text-white font-bold uppercase text-2xl [text-shadow:_2px_2px_0_rgb(155_155_155_/_60%)]">
        PERFIL
      </div>

    </template>
    <template v-slot:content>
      
      <div class="w-full" v-if="usuarioEmpresa">
        <div class="container w-full mx-auto">

          <!-- FORM CARD -->
          <div class="relative w-full shadow-lg rounded-lg bg-white px-4 py-3 pb-5">
            <div class="flex items-center justify-between font-semibold text-lg ">
              MI PERFIL
            </div>

            <div class="container mx-auto block w-full mt-4 space-y-4">

              <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">                
                <div class="w-full px-2 md:w-1/1">
                  <label class="block mb-1">Empresa (Razón social)</label>
                  <Field name="razonSocial" v-slot="{ field }" v-model="usuarioEmpresa.empresa.razonSocial">
                    <InputText v-bind="field" type="text" class="input-base !bg-gray-200" readonly />
                  </Field>
                </div>
              </div>

              <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">                
                <div class="w-full px-2 md:w-1/1">
                  <label class="block mb-1">Nombre de fantasía</label>
                  <Field name="nombreFantasia" v-slot="{ field }" v-model="usuarioEmpresa.empresa.nombreFantasia">
                    <InputText v-bind="field" type="text" class="input-base !bg-gray-200" readonly />
                  </Field>
                </div>
              </div>

              <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
                <div class="w-full px-2 md:w-1/1">
                  <label class="block mb-1">Mail</label>
                  <Field name="mailResponsable" v-slot="{ field }" v-model="usuarioEmpresa.mailResponsable">
                    <InputText v-bind="field" type="text" class="input-base !bg-gray-200" readonly />
                  </Field>
                </div>
              </div>

              <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
                <div class="w-full px-2 md:w-1/1">
                  <label class="block mb-1">Nombre completo</label>
                  <Field name="nombreCompleto" v-slot="{ field }" v-model="usuarioEmpresa.nombreCompleto">
                    <InputText v-bind="field" type="text" class="input-base !bg-gray-200" readonly />
                  </Field>
                </div>
              </div>

              <div class="flex flex-col md:flex-row my-2 gap-2 pt-3">
                <button type="button" @click="showCambiarClave" class="px-4 py-2 bg-transparent border-black hover:bg-black text-black font-semibold hover:text-white border rounded"
                  :disabled="isSubmitting">
                  <font-awesome-icon :icon="['fas', 'lock']" /> CAMBIAR CONTRASEÑA
                </button>
                <button type="button" @click="cancelarModificacion" class="px-4 py-2 bg-transparent border-red-700 hover:bg-red-700 text-red-700 font-semibold hover:text-white border rounded"
                  :disabled="isSubmitting">
                  <i class="pi pi-times mr-2"></i>CANCELAR
                </button>
              </div>

            </div>

          </div>
          <!-- FIN FORM CARD -->
          
        </div>
      </div>

    </template>
  </CommonPrivateView>

  <Dialog v-model:visible="isCambiarClaveVisible" modal header="Cambiar contraseña" :style="{ width: '40rem' }">

    <Form @submit="onSubmit" :validation-schema="schema">
      <div class="container mx-auto block w-full space-y-2">
        <div class="w-full text-center" v-show="errorCambioClave">
          <div class="bg-red-100 text-sm border border-red-300 text-red-700 px-4 py-3 rounded relative">
            <span class="block sm:inline">{{errorCambioClave}}</span>
          </div>
        </div>
        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0">
          <div class="w-full px-2 md:w-1/1">
            <label class="block mb-1">Contraseña actual</label>
            <Field name="claveActual" v-slot="{ field, errors }" v-model="claveActual">
              <InputText v-bind="field" type="password" class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="claveActual" /></span>
            </Field>
          </div>
        </div>
        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0">
          <div class="w-full px-2 md:w-1/1">
            <label class="block mb-1">Nueva contraseña</label>
            <Field name="claveNueva" v-slot="{ field, errors }" v-model="claveNueva">
              <InputText v-bind="field" type="password" class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="claveNueva" /></span>
            </Field>
          </div>
        </div>
        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0">
          <div class="w-full px-2 md:w-1/1">
            <label class="block mb-1">Repetir contraseña</label>
            <Field name="claveRepetida" v-slot="{ field, errors }" v-model="claveRepetida">
              <InputText v-bind="field" type="password" class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="claveRepetida" /></span>
            </Field>
          </div>
        </div>
        <div class="flex flex-col md:flex-row my-2 gap-2 pt-3">
          <button type="submit" class="flex-grow px-4 py-2 bg-transparent border-black hover:bg-black text-black font-semibold hover:text-white border rounded"
            :disabled="isSubmitting">
            <i v-show="isSubmitting" class="pi pi-spin pi-spinner mr-2"></i>
            <i v-show="!isSubmitting" class="pi pi-check mr-2"></i>ACEPTAR
          </button>
          <button type="button" @click="isCambiarClaveVisible = false" class="flex-grow px-4 py-2 bg-transparent border-red-700 hover:bg-red-700 text-red-700 font-semibold hover:text-white border rounded"
            :disabled="isSubmitting">
            <i class="pi pi-times mr-2"></i>CANCELAR
          </button>
        </div>
      </div>
    </Form>

  </Dialog>

  <BlockUI :blocked="isSubmitting" fullScreen />

</template>

<script lang="ts">
import * as yup from 'yup';

import { defineComponent } from 'vue';
import { Field, Form, ErrorMessage } from 'vee-validate';
import Swal from 'sweetalert2'

import BlockUI from 'primevue/blockui';
import InputText from 'primevue/inputtext';
import Dialog from 'primevue/dialog';

import CommonPrivateView from '@/components/commons/CommonPrivateView.vue';

import suiteConfig from '@/services/suite.config';
import empresaService from 'qreventos-suite/empresas';
import seguridadServices from '@/services/seguridad.services';
import { UsuarioEmpresa } from 'qreventos-suite/src/services/suite.interfaces';

export default defineComponent({
  components: {
    InputText, BlockUI, 
    Form, ErrorMessage, Field, Dialog,
    CommonPrivateView
  },
  created() {
    document.title = "Producto";
    suiteConfig.token = "bUJldXJDYnNJRVdFdVVCL3FnbmI4UGtXZ05VMWYzclVtbXdBYU1sclNFWT0=";
  },
  data() {
    return {
      isSubmitting: false,
      isCambiarClaveVisible: false,
      usuarioEmpresa: undefined as unknown as UsuarioEmpresa,
      claveActual: '',
      claveNueva: '',
      claveRepetida: '',
      errorCambioClave: '',
    };
  },
  computed: {
    schema() {
      return yup.object({
        claveActual: yup.string().required('Ingresá la contraseña actual'),
        claveNueva: yup.string().required('Ingresá la nueva contraseña').min(8, 'Al menos 8 caracteres'),
        claveRepetida: yup.string().required('Repetí la contraseña').min(8, 'Al menos 8 caracteres').oneOf([yup.ref('claveNueva')], 'Las contraseñas no coinciden'),
      });
    }
  },
  methods: {
    showCambiarClave() {
      this.errorCambioClave = '';
      this.claveActual = '';
      this.claveNueva = '';
      this.claveRepetida = '';
      this.isCambiarClaveVisible = true;
    },   
    cancelarModificacion() {
      this.$router.push({ path: '/perfil' });
    },
    async fillUsuarioEmpresa() {
      this.isSubmitting = true;

      try {
        this.usuarioEmpresa = seguridadServices.getLocalUsuarioEmpresa() as UsuarioEmpresa;

      } catch(error) {
        this.isSubmitting = false;
        Swal.fire({ title: "Error", text: error + '', icon: "error" });
      } finally {
        this.isSubmitting = false;
      }
    },
    async onSubmit() {
      this.isSubmitting = true;
      this.errorCambioClave = '';

      try {

        const result:string = await empresaService.actualizarAccesoUsuarioEmpresa(this.usuarioEmpresa.evento.id, this.usuarioEmpresa.id, this.claveActual, this.claveNueva) as string;
        if(result == "Ok") {
          this.isSubmitting = false;
          this.isCambiarClaveVisible = false;
          Swal.fire({ title: "¡Atención!", html: 'Tu contraseña fue cambiada con éxito.<br/>Por favor volvé a ingresar con la nueva contraseña.', icon: "success"}).then(() => {
            seguridadServices.logout();
            this.$router.push({ path: '/' });
          });
        }

      } catch(error) {
        this.isSubmitting = false;
        this.errorCambioClave = error + '';
      } finally {
        this.isSubmitting = false;
      }
    }
  },
  async mounted() {
    try {
      empresaService.clientId = suiteConfig.clientId;
      empresaService.token = suiteConfig.token;

      this.fillUsuarioEmpresa();
    }
    catch (error) {
      Swal.fire({ title: "Error", text: 'Sesión expirada [' + error + ']', icon: "error" })
        .then(() => {
          seguridadServices.logout();
          this.$router.push({ path: '/' });
        });
    }
  }
});
</script>
